import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button} from 'react-bootstrap';
import {FmlxIcon} from 'fmlx-common-ui';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';

import {hideLicenseCountdown, showLicenseModal} from '../../stores/actions/licenceStateAction';

import withIntl from '../../lib/withIntl';

import './LicenseCountdown.scss';
import {LicenseStatus} from '../../constants/dataEnum';
import {isUserOperator} from '../../stores/business/userManagementBusiness';

const mapStateToProps = (state) => ({
  licenseRemainingDays: state.licenseState.remainingDays,
  showCountdown: state.licenseState.showCountdown,
  licenseStatus: state.licenseState.status,
});

const mapDispatchToProps = (dispatch) => ({
  licenseStateActionShowLicenseModal: bindActionCreators(showLicenseModal, dispatch),
  licenseStateActionHideLicenseCountdown: bindActionCreators(hideLicenseCountdown, dispatch),
  userManagementBusinessIsOperator: bindActionCreators(isUserOperator, dispatch),
});

function LicenseCountdown({
  intl,
  licenseRemainingDays,
  showCountdown,
  licenseStatus,
  licenseStateActionShowLicenseModal,
  licenseStateActionHideLicenseCountdown,
  userManagementBusinessIsOperator,
}) {
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setIsShow(showCountdown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCountdown]);

  useEffect(() => {
    if (licenseStatus !== LicenseStatus.TRIAL) {
      licenseStateActionHideLicenseCountdown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licenseStatus]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isShow && (
        <div className="license-countdown">
          <div className="license-countdown__logo">
            <FmlxIcon name="Warning" size="xs" customColor="red" />
          </div>
          <div className="license-countdown__content">
            <div className="license-countdown__content__body">
              <FormattedHTMLMessage
                id="licensing.licenseCountdown.text"
                values={{
                  remainingDay: `${licenseRemainingDays} ${parseInt(licenseRemainingDays, 10) > 1 ? 'days' : 'day'}`,
                }}
              />
            </div>
            <div className="license-countdown__content__button">
              <Button
                className={`${userManagementBusinessIsOperator() ? 'button-disabled' : 'button-primary'}`}
                onClick={licenseStateActionShowLicenseModal}
                disabled={userManagementBusinessIsOperator()}
              >
                {intl.formatMessage({id: 'licensing.licenseCountdown.firstButton'})}
              </Button>
              <Button className="button-tertiary" onClick={() => licenseStateActionHideLicenseCountdown()}>
                {intl.formatMessage({id: 'licensing.licenseCountdown.secondButton'})}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

LicenseCountdown.propTypes = {
  intl: PropTypes.any.isRequired,
  licenseRemainingDays: PropTypes.any.isRequired,
  showCountdown: PropTypes.bool.isRequired,
  licenseStatus: PropTypes.string.isRequired,
  licenseStateActionShowLicenseModal: PropTypes.func.isRequired,
  licenseStateActionHideLicenseCountdown: PropTypes.func.isRequired,
  userManagementBusinessIsOperator: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(LicenseCountdown));
